import { render, staticRenderFns } from "./ShoesBest.vue?vue&type=template&id=650c4d8f"
import script from "./ShoesBest.vue?vue&type=script&lang=js"
export * from "./ShoesBest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports